import { Tab, Tabs } from "@mui/material";
import MDBox from "components/MDBox";
import { PERMISSIONS_NAME } from "lib/constants";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { checkPermission } from "utils/HelperFunctions";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import AssignedToMe from "./components/AssignToMe";
import MyTeam from "./components/MyTeam";

function Reports() {
  const user = useSelector((state) => state.loginUser.loginUserState);
  const viewMyTeam = checkPermission(PERMISSIONS_NAME?.MANAGE_COACHUP, user?.userPermission);
  const [selectedTab, setSelectedTab] = useState(!viewMyTeam ? 1 : 0);
  const handleTabChange = (_, value) => {
    setSelectedTab(value);
  };

  return (
    <DashboardLayout>
      {/* header */}
      <DashboardNavbar />
      <MDBox minWidth={{ xs: "22rem", md: "25rem" }} sx={{ width: "25%" }}>
        {viewMyTeam && (
          <Tabs value={selectedTab} onChange={handleTabChange}>
            <Tab
              id="team"
              label={
                <MDBox py={0.5} px={2} color="inherit">
                  My Team
                </MDBox>
              }
            />
            <Tab
              id="assined"
              label={
                <MDBox py={0.5} px={2} color="inherit">
                  Assigned to Me
                </MDBox>
              }
            />
          </Tabs>
        )}
      </MDBox>
      {selectedTab === 0 && <MyTeam />}
      {selectedTab === 1 && <AssignedToMe />}
    </DashboardLayout>
  );
}

export default Reports;
